var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pagination.pageIndex,"page-sizes":[20, 30, 50],"page-size":_vm.pagination.pageSize,"layout":"total, sizes, prev, pager, next","total":_vm.pagination.total,"background":""},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd5aa77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pagination.vue
// module id = null
// module chunks = 